// extracted by mini-css-extract-plugin
export default {"externalContainer":"view-external_externalContainer__cigwT","externalContainerExpanded":"view-external_externalContainerExpanded__T7HxM"};